import React, {
  memo,
  useEffect,
  useState,
  useCallback,
  useLayoutEffect,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import PropTypes from 'prop-types';

import Header from './header';
import Content from './content';
import actions from '@flux/action';

// import '@style/modules/insights/valueDriverManager.scss';
import '../../../styles/modules/insights/valueDriverManager.scss';
import { getValueFromSearchParam } from '@utils/history';
import useConcurrentEditAreaMonitor from '@hooks/useConcurrentEditAreaMonitor';

function ValueDriverManager({ history, location }) {
  const dispatch = useDispatch();
  const data = useSelector(({ insights }) => insights.valueDriverManageData);
  const userInfo = useSelector(({ login }) => login.userInfo);
  const { projectId } = getValueFromSearchParam('projectId');
  const [formExpand, setFormExpand] = useState(false);
  const valueDriverIdentifier = 'value-driver';
  const goBack = () => {
    dispatch(actions.changeLoading(true));
    releaseLock().finally(() => {
      dispatch(actions.changeLoading(false));
      history.push(`/insights/value-driver`);
    });
  };

  const {
    extendAbortController,
    releaseLock,
    queryLockInfo,
    releaseLockBeforeUnload,
  } = useConcurrentEditAreaMonitor({
    selector: '.value-driver-manager',
    identifier: valueDriverIdentifier,
    cancelEdit: goBack,
  });

  const saveData = useCallback(
    async (params) => {
      const { lockInfo } = (await queryLockInfo()) || {};
      if (
        lockInfo.length &&
        lockInfo.some(
          (i) =>
            i.moduleIdentifier === valueDriverIdentifier &&
            i.userEmail === userInfo.email &&
            i.lockStatus,
        )
      ) {
        const res = await dispatch(actions.saveValueDriver(params));
        await releaseLock();
        return res;
      }
    },
    [queryLockInfo, releaseLock],
  );

  useEffect(() => {
    if (!location?.state?.fromView && projectId) {
      return history.replace(`/insights/value-driver?projectId=${projectId}`);
    }
    dispatch(actions.fetchValueDriverManageData());

    return () => {
      dispatch(actions.changeValueDriverManageData(null));
    };
  }, []);

  useLayoutEffect(() => {
    // when page is unload
    function onBeforeunload(e) {
      e.preventDefault();
      if (window.location.pathname.includes('insights/manager')) {
        releaseLockBeforeUnload();
      }
    }

    if (location?.state?.fromView) {
      history.push({ ...location, state: { fromView: false } });
      window.addEventListener('beforeunload', onBeforeunload);
    } else {
      goBack();
    }

    return () => {
      if (extendAbortController.current) {
        extendAbortController.current.abort();
      }
      // when left current page
      releaseLock();
    };
  }, []);

  return (
    <div className="value-driver-manager manage-module-wrapper">
      <Header formExpand={formExpand} goBack={goBack} />
      <Content
        data={data}
        saveData={saveData}
        formExpand={formExpand}
        setFormExpand={setFormExpand}
        goBack={goBack}
      />
    </div>
  );
}

ValueDriverManager.propTypes = {};

export default memo(ValueDriverManager);
